/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_08_27_13_13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TH2FacilityExtendetDTO } from './tH2FacilityExtendetDTO';
import { TCO2FacilityExtendetDTO } from './tCO2FacilityExtendetDTO';


export interface TGetFacilitiesDTO { 
    readonly h2_facility_list?: Array<TH2FacilityExtendetDTO> | null;
    readonly co2_facility_list?: Array<TCO2FacilityExtendetDTO> | null;
}

